
<nz-row *ngIf="exceededAmountValue > 0">
    <p class="credit-exceeded-msg">
        Credit Limit is exceeded by {{currency}} {{exceededAmountValue | number:'1.2-2'}}
    </p>
</nz-row>

<nz-row nzGutter="16" class="input-row">
    <nz-col nzSpan="8" class="label-container">
        <label>Outstanding</label>
    </nz-col>
    <nz-col nzSpan="16">
        <input 
            value="{{outstanding | number:'1.2-2'}}"
            readonly="true"            
            class="input-field"/>
    </nz-col>
</nz-row>

<nz-row nzGutter="16" class="input-row">
    <nz-col nzSpan="8" class="label-container">
        <label>+ Current</label>
    </nz-col>
    <nz-col nzSpan="16">
        <input 
            value="{{current | number:'1.2-2'}}"
            readonly="true"
            class="input-field"/>
    </nz-col>
</nz-row>

<nz-row nzGutter="16" class="input-row">
    <nz-col nzSpan="8" class="label-container">
        <label>- Credit Limit</label>
    </nz-col>
    <nz-col nzSpan="16">
        <input 
            value="{{globalCreditLimit.creditLimit | number:'1.2-2'}}"
            readonly="true"
            class="input-field"/>
    </nz-col>
</nz-row>

<nz-row nzGutter="16" class="input-row">
    <nz-col nzSpan="8" class="label-container credit-label">
        <label>= Credit Exceeded</label>
    </nz-col>
    <nz-col nzSpan="16">
        <input
            value="{{exceededAmountValue | number:'1.2-2'}}"
            readonly="true"
            class="input-field credit-exceeded"/>
       
    </nz-col>
</nz-row>

<nz-row class="valid-until" *ngIf="globalCreditLimit.validUntil">
    <p>Valid Until: {{globalCreditLimit.validUntil | date:'MM/dd/yyyy'}}</p>
</nz-row>

<!-- Footer Buttons -->
<nz-row nzJustify="end" class="mt-md">
    <nz-col>
        <button type="button" class="mx-4" nz-button nzType="primary" *ngIf="globalCreditLimit.exceededBehavior==='W'"
        (click)="saveTransaction()">
        Continue
    </button>
    </nz-col>
    <nz-col>
        <button type="button" nz-button nzType="default" (click)="closeModal()">Close</button>
    </nz-col>
    
</nz-row>

<!-- Styles -->
<style>
    .credit-exceeded-msg {
        font-size: 16px;
        font-weight: bold;
        color: red;
        margin-bottom: 10px;
    }

    .input-row {
        margin-top: 10px;
        display: flex;
        align-items: center;
    }

    .label-container {
        display: flex;
        align-items: center;
        text-align: left;
        padding-right: 10px;
    }

    .credit-label {
        color: black;
    }

    .input-field {
        width: 100%;
        border: 1px solid gray;
        padding: 4px 5px;
    }

    .credit-exceeded {
        font-weight: bold;
        color: #000;
    }

    .valid-until {
        margin-top: 10px;
        font-size: 14px;
        color: #333;
    }

    .mt-md {
        margin-top: 20px;
    }
</style>
